import { FormControl, FormHelperText, InputLabel, SelectProps, useTheme } from "@mui/material";
import React from "react";
import { FilterSelect, NewOrderSelect } from "./styled/orders";
import { GapContainer } from "../card/styled";

export const BarekamSelect = ({ type, label, displayEmpty, error, errorMessage, size, required, ...props }: BarekamSelectProps) => {
    const theme = useTheme();

    switch (type) {
        case "standard":
            return (
                <FormControl error={error} fullWidth>
                    <InputLabel size={size === 'small' ? 'small' : 'normal'}>
                        <GapContainer>
                            {label}
                            {required ? <span style={{ color: '#D42D4A' }}> *</span> : ''}
                        </GapContainer>
                    </InputLabel>

                    <NewOrderSelect
                        sx={{ '& .MuiInputBase-input': { color: displayEmpty ? theme.palette.text.disabled : 'none' } }}
                        MenuProps={{ sx: { padding: 0, height: '30rem' } }}
                        label={label}
                        size={size}
                        {...props} />
                    {error ? <FormHelperText>{errorMessage}</FormHelperText> : <></>}
                </FormControl>
            )
        case "filter":
            return (
                <FormControl error={error} fullWidth>
                    <InputLabel size={size === 'small' ? 'small' : 'normal'}>{label}</InputLabel>
                    <FilterSelect
                        sx={{ '& .MuiInputBase-input': { color: displayEmpty ? theme.palette.text.disabled : 'none' } }}
                        MenuProps={{ sx: { padding: 0 } }}
                        label={label}
                        size={size}
                        {...props} />
                </FormControl>
            )
    }
}

type BarekamSelectProps = SelectProps & {
    type: 'standard' | 'filter',
    errorMessage?: string,
}